module.exports = require("@apollo/client/link/http");